import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToastContext } from '@weezevent/nacre';
import { UploadDropZone } from '../../nacre/uploadButton';
import { downloadFile } from '../../utils/downloadFile';

export default function ChfSepa() {
    const [isUploading, setUploading] = React.useState(false);
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();

    const onFileSelected = React.useCallback(
        async (files, rejected) => {
            setUploading(true);
            const [_file] = files;
            const body = new FormData();
            const headers = { Accept: 'text/xml, application/json' };
            body.append('file', _file);
            try {
                downloadFile('/ticket/accounting/chfsepa', 'SEPAN_CHF.xml', 'application/xml', 'POST', body, headers);
            } catch {
                return toast.error(t('ticket.tools.chfsepa.post_error'));
            } finally {
                setUploading(false);
            }
        },
        [setUploading]
    );

    return (
        <div className="chfsepa">
            <h1 className="header">{t('ticket.tools.chfsepa.title')}</h1>
            <UploadDropZone acceptedFileExtensions={['.csv']} isUploading={isUploading} onFileSelected={onFileSelected} label={t('ticket.tools.chfsepa.uploadLabel')} />
        </div>
    );
}
